import mixpanel from 'mixpanel-browser';

mixpanel.init('a4f23436f422e3272105a0ef5580d63b', {debug: false});
mixpanel.set_config({'persistence': 'localStorage'});

export default mixpanel;